// Import external
import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({

    selector: 'syn-in-array',
    templateUrl: 'in-array.component.html'
})

export class InArrayComponent implements OnInit {

    @Input() needle: string;
    @Input() stack: string[];

    public icon = 'minus';
    public className = 'syn-text--muted';

    ngOnInit() {
        if (this.stack && this.stack.length > 0) {
            if (_.includes(this.stack, this.needle)) {
                this.icon = 'check';
                this.className = 'syn-text--success';
            } else {
                this.icon = 'close';
                this.className = 'syn-text--danger';
            }
        }
    }

}
